import { TApiResponse } from '@/common/types/response';

import { TEventsState } from './types';

export function setEvents(state: TEventsState, res: TApiResponse<TEventsState['listOfEvents']>) {
  state.listOfEvents = res.data;
}

export function setEventsTable(state: TEventsState, res: TApiResponse<TEventsState['eventsTable']>) {
  state.eventsTable = res.data;
}

export function setMinistryEventsTable(state: TEventsState, res: TApiResponse<TEventsState['ministryEventsTable']>) {
  state.ministryEventsTable = res.data;
}

export function setIndicatorCards(state: TEventsState, res: TApiResponse<TEventsState['indicatorCards']>) {
  state.indicatorCards = res.data;
}
